// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1STFP","cell":"ColumnAccessor_cell__1mCoK","firstCellAccent":"ColumnAccessor_firstCellAccent__aILPZ"};